import { SHOPPING_LISTS_ENDPOINTS } from "./endpoints";
import type { CreateListResponse, CreateShoppingListRequest } from "./types";
import { apiPostWithData } from "../shared";

function buildRequestBody(request?: CreateShoppingListRequest) {
  if (!request?.supermarketCodes?.length) {
    return undefined;
  }

  return {
    supermarket_codes: request.supermarketCodes,
  };
}

export async function createShoppingList(request?: CreateShoppingListRequest): Promise<CreateListResponse> {
  return apiPostWithData<CreateListResponse>(SHOPPING_LISTS_ENDPOINTS.CREATE, buildRequestBody(request));
}

export default createShoppingList;
